import React, { useMemo } from 'react';
import { Button } from 'antd';

import { RenderIf } from 'components/components';
import { UserRoleType } from 'types/auth';
import { isEitherAdmin, identity } from 'utils';

type UploadButtonProps = {
  name: string,
  onClick: React.MouseEventHandler<HTMLButtonElement>,
  condition: boolean,
  status: number,
  userType: UserRoleType,
  disabled?: boolean,
  helperText?: string,
  title?: string,
}

const ViewUploadButton = (props: UploadButtonProps) => {
  const {
    name, onClick, condition, status, userType, disabled, helperText, title,
  } = props;

  const buttonText = useMemo(() => {
    if (condition) {
      return `View ${name} details`;
    }
    return `${status === 2 ? 'Change' : 'Upload'} ${name}`;
  }, [condition, status]);

  return (
    <div className="edit-angelinvestor__view-upload-button__container">
      {isEitherAdmin(userType) && !condition
        ? (
          <Button
            className="secondary-button md"
            onClick={onClick}
            disabled={disabled}
            title={title}
          >
            {buttonText}
          </Button>
        )
        : (
          <Button
            className="secondary-button md"
            onClick={onClick}
            disabled={disabled}
            title={title}
          >
            {buttonText}
          </Button>
        )}
      <RenderIf condition={identity.isTruthyString(helperText)}>
        <p className="edit-angelinvestor__view-upload-button__rejected-document-text">
          {helperText}
        </p>
      </RenderIf>
      <RenderIf condition={status === 2}>
        <p className="edit-angelinvestor__view-upload-button__rejected-document-text">{`${name} has been rejected. Please upload a new one.`}</p>
      </RenderIf>
    </div>
  );
}

ViewUploadButton.defaultProps = {
  disabled: false,
  helperText: '',
  title: '',
}

export default ViewUploadButton;
